class TSContact extends HTMLElement {
  constructor() {
    super();
    this.customerLogedIn = this.dataset.customer === "true";
    this.isBot = false;
    this.hCaptcha = null;
  }

  connectedCallback() {
    this.formStart = Date.now();

    this.formError = this.querySelector(".form-error");

    //Setup contries
    if (this.querySelector("[data-field-country]")) {
      const field = this.querySelector("[data-field-country]");
      const options = this.querySelectorAll("[data-contries] option");
      const selectedOption = options[0];
      const select = field.querySelector(".ts-contact__select");
      let skipDefault = false;

      field.querySelector("input").value = selectedOption.value;

      options.forEach((option) => {
        if (!skipDefault) {
          skipDefault = option.value === "---";
        } else {
          if (option.value !== "Russia") {
            const markup = `<div class="ts-contact__option${
              option.value === selectedOption.value ? " active" : ""
            }" data-trigger="select-option">${option.value}</div>`;
            select.insertAdjacentHTML("beforeend", markup);
          }
        }
      });
    }

    this.initClickEvents();
    this.initInputEvents();
    this.initSubmitEvents();
    this.initHCaptcha();

    // Remove ?contact_posted=true from URL
    const url = new URL(window.location.href);
    if (url.searchParams.has("contact_posted")) {
      url.searchParams.delete("contact_posted");
      window.history.replaceState({}, document.title, url.toString());
    }
  }
  initHCaptcha() {}

  looksLikeGibberish(text) {
    const clean = text.replace(/[^a-zA-Z]/g, "");

    // Too short
    if (clean.length < 3) return true;

    // Repeated characters
    if (/(.)\1{3,}/.test(clean)) return true;

    // Consonant/vowel ratio
    const vowels = (clean.match(/[aeiou]/gi) || []).length;
    const consonants = (clean.match(/[bcdfghjklmnpqrstvwxyz]/gi) || []).length;
    if (consonants > vowels * 4) return true;

    return false;
  }
  validateFields(form) {
    if (!form) return false;
    let hasNoErrors = true;

    form.querySelectorAll("[data-field]").forEach((field) => {
      const input = field.querySelector("input, textarea");
      const errorField = field.querySelector("[data-field-error]");

      if (input.name == "inquiry") {
        if (!input.value.trim()) {
          errorField.innerText = window.contactStrings.inquiry;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      } else if (input.name == "message") {
        if (!input.value.trim()) {
          errorField.innerText = window.contactStrings.body;
          hasNoErrors = false;
        } else if (input.value.length > 2000) {
          errorField.innerText = window.contactStrings.body_limit;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      } else if (input.name == "first_name") {
        if (!input.value.trim()) {
          errorField.innerText = window.contactStrings.name;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      } else if (input.name == "last_name") {
        if (!input.value.trim()) {
          errorField.innerText = window.contactStrings.surname;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      } else if (input.name == "email") {
        if (!input.value.trim()) {
          errorField.innerText = window.contactStrings.email_empty;
          hasNoErrors = false;
        } else if (!input.checkValidity()) {
          errorField.innerText = window.contactStrings.email;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      } else if (input.name == "email-confirm") {
        if (!input.value.trim()) {
          errorField.innerText = window.contactStrings.email_validation_empty;
          hasNoErrors = false;
        } else if (
          input.value.trim() !==
          form.querySelector("[name='email']").value.trim()
        ) {
          errorField.innerText = window.contactStrings.email_validation;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      } else if (input.name == "consent") {
        if (!input.checked) {
          errorField.innerText = window.contactStrings.consent;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      } else if (input.name == "store") {
        if (input.value.trim()) {
          this.isBot = true;
        }
      } else if (input.name == "order") {
        if (input.value.trim()) {
          const trimmedValue = input.value.trim();
          const teNumberPattern = /^(?:DB\d+|\d+)$/i;
          if (!teNumberPattern.test(trimmedValue)) {
            errorField.innerText = window.contactStrings.order_number_format;
            hasNoErrors = false;
            //   } else if (
            //     !field.querySelector(
            //       `[data-orders] [data-order="${input.value.trim()}"]`
            //     )
            //   ) {
            //     errorField.innerText = window.contactStrings.order_number_wrong;
            //     hasNoErrors = false;
          } else {
            errorField.innerText = "";
          }
        } else {
          errorField.innerText = "";
        }
      }
    });

    return hasNoErrors;
  }

  initClickEvents() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-trigger")) {
        switch (e.target.dataset.trigger) {
          case "close":
            this.querySelector(".ts-contact__success").classList.remove("open");
            break;
          case "toggle-select":
            e.target.classList.toggle("open");
            break;
          case "select-option":
            const select = e.target.closest("[data-field-select]");
            select.classList.remove("open");
            select.querySelector("input").value = e.target.innerText;
            select.querySelector(".active")?.classList.remove("active");
            e.target.classList.add("active");
            this.validateFields(this.querySelector("form"));
            break;
        }
      }
    });

    document.addEventListener("click", (e) => {
      if (!e.target.closest("[data-field-select]")) {
        this.querySelectorAll("[data-field-select]").forEach((select) => {
          if (select !== e.target.closest("[data-field-select]")) {
            select.classList.remove("open");
          }
        });
      }
    });
  }

  initInputEvents() {
    this.addEventListener("input", (e) => {
      const target = e.target;
      this.validateFields(this.querySelector("form"));

      // Auto-resize logic for textareas
      if (target.tagName === "TEXTAREA") {
        target.style.height = "auto"; // Reset height
        target.style.height = `${target.scrollHeight}px`; // Set to content height
      }
    });
  }

  initSubmitEvents() {
    const contactSubmitButton = this.querySelector("form button");

    contactSubmitButton.addEventListener("click", (e) => {
      e.preventDefault();

      this.formError.classList.remove("form-error--active");

      const form = this.querySelector("form");
      if (!this.validateFields(form)) return;
      const timeSpent = (Date.now() - this.formStart) / 1000; // seconds
      if (timeSpent < 3) {
        contactSubmitButton.setAttribute("disabled", true);
        contactSubmitButton.classList.add("contact__button--loading");

        setTimeout(() => {
          contactSubmitButton.removeAttribute("disabled");
          contactSubmitButton.classList.remove("contact__button--loading");
          this.formStart = Date.now();
        }, 2000);
        return;
      }

      if (this.isBot) {
        form.reset();
        this.querySelector(".ts-contact__success").classList.add("open");
        this.isBot = false;
        return;
      }

      const formData = new FormData(form);
      const dataJson = Object.fromEntries(formData.entries());

      const data = {
        first_name: dataJson.first_name,
        last_name: dataJson.last_name,
        email: dataJson.email,
        inquiry: dataJson.inquiry,
        message: dataJson.message,
        locale: window.language,
        country: dataJson.country || null,
        hCaptcha: dataJson["h-captcha-response"] || null,
      };

      if (dataJson["order"]) data.order = dataJson.order;

      contactSubmitButton.setAttribute("disabled", true);
      contactSubmitButton.classList.add("contact__button--loading");

      fetch(`${window.apiURL}/contact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          console.log(response);
          return response.json();
        })
        .then((data) => {
          console.log(data);
          if (data.message == "email_sent") {
            this.querySelector(".ts-contact__success").classList.add("open");
            form.reset();
          } else if (data.message == "invalid_captcha") {
            this.formError.classList.add("form-error--active");
            this.formError.innerText = errorMessages?.form?.invalid_captcha;
          }
        })
        .catch((error) => console.log(error, data))
        .finally(() => {
          contactSubmitButton.removeAttribute("disabled");
          contactSubmitButton.classList.remove("contact__button--loading");
        });
    });
  }
}

customElements.define("ts-contact", TSContact);

class ComponentAccordion extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.trigger = this.querySelector("[data-accordion-trigger]");
    this.target = this.querySelector("[data-accordion-target]");
    this.initClickEvents();
  }

  open() {
    this.target.classList.add("accordion--active");
  }
  close() {
    this.target.classList.remove("accordion--active");
  }
  toggle() {
    this.target.classList.toggle("accordion--active");
  }
  initClickEvents() {
    this.trigger.addEventListener("click", (e) => {
      this.toggle();
    });
  }
}

customElements.define("component-accordion", ComponentAccordion);
